export const HIGHLIGHT_PRE_TAG = '__aa-highlight__';
export const HIGHLIGHT_POST_TAG = '__/aa-highlight__';
